var React = require('react');

function HyperIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0,0V249H249V0ZM188,203H151.67V140.63H97.38V203H61V46H97.33v63.48h54.29V46H188Z"}));
}

HyperIcon.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 249 249"};

module.exports = HyperIcon;

HyperIcon.default = HyperIcon;
